<template>
    <div class="main">
        <i
            class="el-icon-circle-check-outline
"
            style="font-size: 65px; color: rgb(14,167,55);"
        ></i>

        <div class="tip1">申请表提交完成</div>
        <div class="tip2">请留意团队负责人邮箱查收申请结果邮件</div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.main {
    text-align: center;
    margin: 150px auto 30px;
}
.tip1 {
    margin-top: 15px;
    font-size: 24px;
}
.tip2 {
    margin-top: 10px;
}
</style>
